// @flow

//  FIXME: We need to separate out this code to reuse it in other places.
//  Details available at https://locussh.atlassian.net/browse/ES-41749

const DEFAULT_VALUE = 'x';

type Props = {
    element: HTMLInputElement,
    maxRows?: number
};

const getCloneElementForCalculation = (element: HTMLElement) => {
    const { width } = element.getBoundingClientRect();
    const { paddingLeft, paddingRight, font } = getComputedStyle(element);

    const cloneElement = document.createElement('span');
    const cloneElementWidth =
        width - (parseInt(paddingLeft) + parseInt(paddingRight));

    cloneElement.style.width = `${cloneElementWidth}px`;
    cloneElement.style.position = 'absolute';
    cloneElement.style.wordBreak = 'break-all';
    cloneElement.style.font = font;

    return cloneElement;
};

const calculateNodeHeight = ({
    element,
    maxRows = Number.POSITIVE_INFINITY
}: Props): number => {
    const value = element.value || element.placeholder || DEFAULT_VALUE;
    const { paddingTop, paddingBottom } = getComputedStyle(element);

    const cloneElement = getCloneElementForCalculation(element);
    document.getElementsByTagName('body')[0].appendChild(cloneElement);

    cloneElement.innerText = 'x';
    const singleRowHeight = cloneElement.scrollHeight;
    cloneElement.innerText = value;
    let currentHeight = cloneElement.scrollHeight;

    // When absolute element is ignoring text with only space characters, then we send back current element offsetHeight
    if (currentHeight === 0) {
        return element.offsetHeight;
    }
    const maxHeight = singleRowHeight * maxRows;

    // new line char (\n) in end signifies extra line which misses in calculation directly with empty text.
    // Hence added it's height separately.
    const isEnterInLastLine = cloneElement.innerHTML.trim().endsWith('<br>');
    currentHeight = currentHeight + (isEnterInLastLine ? singleRowHeight : 0);

    document.getElementsByTagName('body')[0].removeChild(cloneElement);

    const paddingY = parseInt(paddingTop) + parseInt(paddingBottom);
    const isMaxRowBreached = maxHeight <= currentHeight;
    const finalHeight = !isMaxRowBreached ? currentHeight : maxHeight;

    return finalHeight + paddingY;
};

export default calculateNodeHeight;
